<!-- Floating draggable chat panel -->
<div class="chat-panel">
  <!-- Drag handle + minimize button -->
  <div class="drag-handle" (mousedown)="onDragStart($event)">
    <span class="drag-handle-label">Instant Messaging</span>
    <button class="minimize-btn" (click)="minimize()" aria-label="Minimize chat">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#666">
        <path d="M19 13H5v-2h14v2z"/>
      </svg>
    </button>
  </div>

  @if (sessionError()) {
    <div class="session-error">
      <p>{{ sessionError() }}</p>
      <p class="error-hint">The chat widget requires a valid session. Please log in.</p>
    </div>
  } @else if (!isPickingUser()) {
    <app-chat-window />
  } @else {
    <div class="user-picker">
      <h3>Select User</h3>
      @for (user of state.users(); track user.id) {
        <button class="user-row" (click)="pickUser(user)">
          <img [src]="user.avatarUrl" class="user-avatar" alt="" />
          <span>{{ user.displayName }}</span>
        </button>
      }
    </div>
  }
</div>
